package amazon.lastmile.inject

import com.karawek.core.auth.presenter.OtpVerificationPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = OtpVerificationPresenterFactory::class)
public interface ComKarawekCoreAuthPresenterOtpVerificationPresenterFactory {
  @Provides
  @IntoSet
  public fun provideOtpVerificationPresenterFactoryFactoryMultibinding(otpVerificationPresenterFactory: OtpVerificationPresenterFactory): Presenter.Factory = otpVerificationPresenterFactory
}
